// extracted by mini-css-extract-plugin
export default {"wrap":"text_wrap__jLBH9","table":"text_table__D827G"};